import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import { Button, FormHelperText, TextField } from '@mui/material'
import CustomInput from '../components/styled/CustomInput.styled'
import { saveOrUpdateDataById } from '../apis/generalApis'
import Swal from 'sweetalert2'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const AddPaymentCardModal = ({
  handleAddPaymentCardModal,
  addPaymentCardModal = false,
}) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [cardDetails, setCardDetails] = React.useState({
    user_id: user?.id,
    card_number: '',
    valid_till: '',
    cvv: '',
  })

  const handleChange = (e) => {
    setCardDetails((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const handleAddPaymentCardDetails = async (e) => {
    e.preventDefault()
    let body = { ...cardDetails }
    let result = await saveOrUpdateDataById('add-card', body)
    if (
      result?.success === true &&
      result?.message === 'Card added successfully'
    ) {
      handleAddPaymentCardModal(false)
      Swal.fire({
        icon: 'success',
        title: result?.message,
        timer: 300,
        confirmButtonColor: '#2597F6',
      })
    }
  }

  return (
    <>
      <Modal
        open={addPaymentCardModal}
        onClose={() => handleAddPaymentCardModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="common-modal-width change-password">
          <form onSubmit={handleAddPaymentCardDetails}>
            <div>
              <h3 className="mb-4 fs-24">Add Card</h3>
              <div>
                <FormHelperText
                  id="input-label"
                  className="mt-3"
                  margin="dense"
                >
                  Card Number
                </FormHelperText>
                <TextField
                  margin="dense"
                  placeholder="#### #### #### ####"
                  fullWidth={true}
                  type="text"
                  name="card_number"
                  aria-valuemax={3}
                  aria-valuemin={3}
                  required
                  value={cardDetails.card_number}
                  onChange={handleChange}
                />
              </div>
              <div>
                <FormHelperText
                  id="input-label"
                  className="mt-3"
                  margin="dense"
                >
                  Valid Till
                </FormHelperText>
                <TextField
                  margin="dense"
                  placeholder="##/##"
                  fullWidth={true}
                  type="text"
                  name="valid_till"
                  aria-valuemax={3}
                  aria-valuemin={3}
                  required
                  value={cardDetails.valid_till}
                  onChange={handleChange}
                />
              </div>
              <div>
                <FormHelperText
                  id="input-label"
                  className="mt-3"
                  margin="dense"
                >
                  CVV
                </FormHelperText>
                <TextField
                  margin="dense"
                  placeholder="###"
                  fullWidth={true}
                  type="number"
                  required
                  name="cvv"
                  value={cardDetails.cvv}
                  onChange={handleChange}
                />
              </div>
              <Button
                fullWidth
                type="submit"
                disableElevation
                id="btn-primary-no-shadow"
                className="pointer mt-5"
              >
                Add Card
              </Button>
            </div>
          </form>
        </Box>
      </Modal>
    </>
  )
}

export default AddPaymentCardModal
